import { API } from '../../../../Root';
import { catchBlockErrors } from '../../../../shared/utils/sentry';
import { setActivityLog } from './actions';
import * as types from './actionTypes';

const MUTATION_ACTIONS = [
  types.ADD_CONTACT,
  types.UPDATE_CONTACT,
  types.DELETE_CONTACT,
  types.ADD_NOTE,
  types.UPDATE_NOTE,
  types.DELETE_NOTE,
  types.DELETE_ATTACHED_FILE,
  types.UPDATE_EQUIPMENT,
  types.DELETE_EQUIPMENT,
  types.UPDATE_CREW,
  types.DELETE_CREW,
  types.UPDATE_PEOPLE,
  types.DELETE_PEOPLE,
  types.ADD_LINE_TYPE,
  types.UPDATE_LINE_TYPE,
  types.DELETE_LINE_TYPE,
];

const REFETCH_ACTIONS = [
  types.SET_CREW,
  types.SET_EQUIPMENT,
  types.SET_PEOPLE,
  types.SET_ATTACHED_FILES,
];

export const activityLogMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  const isMutation = MUTATION_ACTIONS.includes(action.type);
  const isUserRefetch = 
    REFETCH_ACTIONS.includes(action.type) && 
    action.meta?.isUserAction === true;

  if (isMutation || isUserRefetch) {
    const state = store.getState();
    const jobID = state.jobDashboard.get('currentJobID');

    if (jobID) {
      const fetchActivityLog = async () => {
        try {
          setTimeout(async () => {
            await API.subscribe(
              {
                endpoint: `job_dashboard/${jobID}/activity_log`,
                method: 'get',
              },
              setActivityLog
            );
          }, 1000);
        } catch (error) {
          catchBlockErrors({ error, fileFunction: 'activityLogMiddleware.fetchActivityLog' });
        }
      };

      fetchActivityLog();
    }
  }

  return result;
};

